import React from "react";
import cx from "classnames";
import { useDrag } from "react-dnd";
import { getEmptyImage } from "react-dnd-html5-backend";

import { Ellipsis } from "@common/components/Ellipsis";

import { InternalFieldPrimaryList } from "@modules/spreadsheets/pages/spreadsheet-details/components/spreadsheet-management/spreadsheet-management.types";

import "./field.styles.scss";

type FieldProps = {
  className?: string;
  field: InternalFieldPrimaryList;
  isFieldsFromSearch?: boolean;
  isSelected?: boolean;
  onMouseDown: (params: { item: InternalFieldPrimaryList; event: React.MouseEvent<HTMLDivElement> }) => void;
  onMouseUp: (params: { item: InternalFieldPrimaryList; event: React.MouseEvent<HTMLDivElement> }) => void;
  onDoubleClick?: (params: { item: InternalFieldPrimaryList; event: React.MouseEvent<HTMLDivElement> }) => void;
  getId: {
    rowId: string;
  };
  onDrag?: (item: InternalFieldPrimaryList) => void;
};

export const Field: React.FC<FieldProps> = (props) => {
  const { className, field, isFieldsFromSearch, isSelected, getId, onMouseDown, onMouseUp, onDoubleClick, onDrag } = props;

  const [{}, dragRef, dragPreview] = useDrag({
    type: "field",
    item: () => field,
    end: (item, monitor) => {
      const dropResult = monitor.getDropResult();
      if (item && dropResult && onDrag) {
        onDrag(item);
      }
    },
    collect: (monitor) => ({
      isDragging: monitor.isDragging(),
    }),
  });

  React.useEffect(function hideDefaultPreview() {
    dragPreview(getEmptyImage(), { captureDraggingState: true });
  }, []);

  return (
    <div className={cx("SpreadsheetDetailsSpreadsheetManagementField", className)}>
      <div
        id={getId.rowId}
        className={cx("SpreadsheetDetailsSpreadsheetManagementField__content-row", {
          "SpreadsheetDetailsSpreadsheetManagementField__content-row--selected": isSelected,
        })}
        onMouseDown={(event: React.MouseEvent<HTMLDivElement>) => onMouseDown({ item: field, event })}
        onMouseUp={(event: React.MouseEvent<HTMLDivElement>) => onMouseUp({ item: field, event })}
        onDoubleClick={(event: React.MouseEvent<HTMLDivElement>) => onDoubleClick && onDoubleClick({ item: field, event })}
        ref={dragRef}
      >
        <div className="SpreadsheetDetailsSpreadsheetManagementField__table-cell">
          <img
            className="SpreadsheetDetailsSpreadsheetManagementField__table-cell__icon"
            src={field.imageURL}
            alt={field.name}
          />
          <Ellipsis text={isFieldsFromSearch? `${field.fullPath}`: (field.parentField?.name ? `${field.parentField.name}.${field.name}` : field.name)} title="Drag fields from this warehouse and drop them on the target window"/>
        </div>
      </div>
    </div>
  );
};
